// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"273": "9c1b6910","459": "24ddebf6","976": "78015ccf",}[chunkId] + ".chunk.js"
}